import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { AdminInvoiceService } from '@/modules/invoice/services/admin-invoice.service'
import { InvoiceResourceModelInAdmin } from '@/modules/invoice/models/invoice-reource.model'
import { InvoiceRequestModel } from '@/modules/invoice/models/invoice-request.model'

@vservice()
export class InvoiceCreateUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: AdminInvoiceService
  ) {
  }

  isLoading = false
  isSuccess = false

  execute(data: InvoiceResourceModelInAdmin, notify: boolean) {
    return this.service.store(this.requestData(data, notify))
      .onStart(() => {
        this.isLoading = true
        this.isSuccess = false
      })
      .onFinish(() => {
        this.isLoading = false
      })
      .onSuccess(() => {
        this.isSuccess = true
      })
  }

  requestData(data: InvoiceResourceModelInAdmin, notify: boolean): InvoiceRequestModel {
    return {
      description: data.description,
      due_date: data.due_date,
      items: data.items,
      model_id: data.model_id,
      model_type: data.model_type,
      notify_to_user: notify,
      profit: data.profit,
      title: data.title,
      user_id: data.user.id
    }
  }

}
